import { defineMessages } from 'react-intl';

const definedMessages = defineMessages({
  tAndC: {
    id: 'app.signup.account.t_and_c',
    description: 'T&Cs message',
    defaultMessage: 'By signing up you agree to the {terms} and {privacy}',
  },
  terms: {
    id: 'app.signup.account.terms',
    description: 'T&Cs message',
    defaultMessage: 'terms & conditions',
  },
  privacy: {
    id: 'app.signup.account.privacy',
    description: 'T&Cs message',
    defaultMessage: 'privacy policy',
  },
  name: {
    id: 'app.signup.account.name',
    description: 'Name label',
    defaultMessage: 'Name',
  },
  phone: {
    id: 'app.signup.account.phone',
    description: 'label',
    defaultMessage: 'Phone',
  },
  password: {
    id: 'app.signup.account.password',
    description: 'label',
    defaultMessage: 'Password',
  },
  email: {
    id: 'app.signup.account.email',
    description: 'email label',
    defaultMessage: 'Work Email',
  },
  businessName: {
    id: 'app.signup.account.business_name',
    description: 'label',
    defaultMessage: 'Business Name',
  },
  staff: {
    id: 'app.signup.account.staff',
    description: 'label',
    defaultMessage: 'Number of staff',
  },
  selectStaff: {
    id: 'app.signup.account.selectStaff',
    description: 'label',
    defaultMessage: 'Select number',
  },
  signUp: {
    id: 'app.signup.account.button',
    description: 'label',
    defaultMessage: 'Sign Up',
  },
  freeTrialButton: {
    id: 'app.signup.account.free_trial_button',
    description: 'label',
    defaultMessage: 'Start free trial',
  },
  freeTrialLabel: {
    id: 'app.signup.account.free_trial_label',
    description: 'label',
    defaultMessage: '14 days free. No credit card required.',
  },
  staffError: {
    id: 'app.signup.account.staff_error',
    description: 'Name error',
    defaultMessage: 'Add your staff count',
  },
  nameError: {
    id: 'app.signup.account.name_error',
    description: 'Name error',
    defaultMessage: 'Add your name',
  },
  businessNameError: {
    id: 'app.signup.account.business_name_error',
    description: 'error',
    defaultMessage: 'Add your business name',
  },
  emailPlaceholder: {
    id: 'app.signup.account.email_placeholder',
    description: 'Email placeholder',
    defaultMessage: 'name@yourbusiness.com',
  },
  phonePlaceholder: {
    id: 'app.signup.account.phone_placeholder',
    description: 'placeholder',
    defaultMessage: 'At least 8 digits',
  },
  passwordPlaceholder: {
    id: 'app.signup.account.password_placeholder',
    description: 'placeholder',
    defaultMessage: 'At least 9 characters',
  },
  alreadyHaveAccount: {
    id: 'app.signup.account.already_have_account',
    description: 'Error message',
    defaultMessage: 'Already have an account?',
  },
  validEmailError: {
    id: 'app.signup.account.valid_email_error',
    description: 'Error message',
    defaultMessage: 'Add a valid email - ',
  },
  phoneError: {
    id: 'app.signup.account.phone_error',
    description: 'Error message',
    defaultMessage: 'Add a valid phone number',
  },
  passwordError: {
    id: 'app.signup.account.password_error',
    description: 'Error message',
    defaultMessage: 'Enter at least 9 characters',
  },
  signUpCount5Less: {
    id: 'app.signup.account.count_5_less',
    description: 'Signup count',
    defaultMessage: 'Fewer than 5',
  },
  signUpCount15Less: {
    id: 'app.signup.account.count_15_less',
    description: 'Signup count',
    defaultMessage: '6 - 15',
  },
  signUpCount25Less: {
    id: 'app.signup.account.count_25_less',
    description: 'Signup count',
    defaultMessage: '16 - 25',
  },
  signUpCount100Less: {
    id: 'app.signup.account.count_100_less',
    description: 'Signup count',
    defaultMessage: '26 - 100',
  },
  signUpCount100Plus: {
    id: 'app.signup.account.count_100_plus',
    description: 'Signup count',
    defaultMessage: '100+',
  },
});

export default definedMessages;



// WEBPACK FOOTER //
// ./src/components/sign_up/sign_up_account/i18n.js